var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.105,
    height: 24.692,
    viewBox: "0 0 26.105 24.692",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_206",
    "data-name": "Gruppe 206",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_139",
    "data-name": "Pfad 139",
    d: "M0,28.664l10.436.459,15.669-.1-9.518-.474Z",
    transform: "translate(0 -23.487)",
    fill: "#032630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_140",
    "data-name": "Pfad 140",
    d: "M16.587,0,0,.2V5.177l16.587-.119Z",
    transform: "translate(0)",
    fill: "#014a5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_141",
    "data-name": "Pfad 141",
    d: "M93.608,0V5.058l9.518.475V.8Z",
    transform: "translate(-77.021)",
    fill: "#038eb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_142",
    "data-name": "Pfad 142",
    d: "M0,115.11l16.587.2v-5.058L0,110.134Z",
    transform: "translate(0 -90.619)",
    fill: "#014a5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_143",
    "data-name": "Pfad 143",
    d: "M93.608,108.6v5.058l9.518-.8v-4.729Z",
    transform: "translate(-77.021 -88.968)",
    fill: "#038eb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_144",
    "data-name": "Pfad 144",
    d: "M0,108l16.587.119,9.518-.474-15.669-.1Z",
    transform: "translate(0 -88.485)",
    fill: "#032630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_145",
    "data-name": "Pfad 145",
    d: "M0,55.444v4.975l16.587.041V55.4Z",
    transform: "translate(0 -45.585)",
    fill: "#024050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_146",
    "data-name": "Pfad 146",
    d: "M93.608,60.461l9.518-.165V55.567L93.608,55.4Z",
    transform: "translate(-77.021 -45.585)",
    fill: "#038eb1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menu.413715f6554cc5d4b4853cf3572c73f6.svg";